import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { AttributeAliasCreateRequest } from '@/api/handlers/resources/attributeTypes/requests';
import type { ApiResponse } from '@/api/handlers/responses';
import type { AttributeAlias } from '@/api/models';
import { AttributeQueryKeys } from './attributeQueryKeys';

export type CreateAttributeAliasVariables = {
    typeId: string;
    valueId: string;
    body: AttributeAliasCreateRequest;
};

export const useCreateAttributeAliasMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<
        ApiResponse<AttributeAlias>,
        Error,
        CreateAttributeAliasVariables
    >({
        mutationFn: ({ typeId, valueId, body }) =>
            apiClient.attributeTypes.createAlias(typeId, valueId, body),
        onSuccess: (result) => {
            if (result.success) {
                queryClient.invalidateQueries({
                    queryKey: AttributeQueryKeys.all,
                });
            }
        },
    });
};
